<!--

  O template App eh a raiz do site. Nela, temos acesso a todas as outras
páginas atraves do <router-view>. Ele funciona como uma caixa ao permitir
que outros componentes existam atraves dela pela rota. As rotas são
declaradas no main.js

@Author Chris
-->

<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    id: 'app',
    metaInfo: {
      title: 'A sua história é importante',
      titleTemplate: '%s - Chapstory',
      meta: [
        {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {name: 'description', content: 'Aqui é o lugar para contar sua história.'}
      ]
    }
  }
</script>

<style lang="scss" scoped>

</style>
